import { render, staticRenderFns } from "./IsPremiseFurnishedQuestion.vue?vue&type=template&id=62706ac8&scoped=true"
import script from "./IsPremiseFurnishedQuestion.vue?vue&type=script&lang=ts"
export * from "./IsPremiseFurnishedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62706ac8",
  null
  
)

export default component.exports